import { render, staticRenderFns } from "./SavedLeadsTab.vue?vue&type=template&id=6999e065&"
import script from "./SavedLeadsTab.vue?vue&type=script&lang=js&"
export * from "./SavedLeadsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports